import { mapState, mapActions } from 'vuex';

import { useDataLoading, usePagination } from '@mixins/factories';

const dataLoadingOptions = {
  getterName: 'getNotificationsHistory', contentName: 'notificationsHistory', searchable: false,
};
const paginationOptions = { contentName: 'notificationsHistory' };

const notificationsHistoryHeaders = Object.freeze([
  { text: 'Job', value: 'jobId' },
  { text: 'Basket', value: 'basketId' },
  { text: 'Outer ID', value: 'outerId' },
  { text: 'Operator', value: 'operatorName' },
  { text: 'Created Date', value: 'created' },
  { text: 'Accepted Date', value: 'accepted' },
  { text: 'Reason', value: 'reason' },
]);

export default {
  name: 'NotificationsHistory',
  mixins: [
    useDataLoading(dataLoadingOptions),
    usePagination(paginationOptions),
  ],
  data() {
    return {
      notificationsHistoryHeaders,
    };
  },
  computed: {
    ...mapState('locations', ['suffix']),
    ...mapState('notifications', ['notificationsHistory']),
  },
  methods: {
    ...mapActions('notifications', ['getNotificationsHistory']),
  },
};
